import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { MarketListView } from './market-list.view';
import { MarketListDataService } from './market-list.data';

@observer
export class MarketListController extends React.Component<ControllerProps<any>, any> {
    protected dataService: MarketListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    constructor(props) {
        super(props);
        this.dataService = MarketListDataService.make();
    }

    componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: MarketSummary): any {
        this.props.history.push(`/general/market/${item == null ? 'new' : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
        this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.addSorting('id', 'asc', true);
        this.dataService.load(query => query)
            .catch(error => {
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            })
            .then(() => {
                this.props.setBusy(false)
            });
    }

    render() {
        return (
            <MarketListView
                model={this.dataService}
                setBusy={this.props.setBusy}
                onItemDoubleClicked={this.onItemDoubleClicked}
                {...this.props }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/market/list/market-list.controller.tsx